import {CITIES_GET_ERROR, CITIES_GET_REQUESTING, CITIES_GET_SUCCESS} from "./constants";

const initialState = {
    requesting: false,
    success: false,
    error: '',
    cities: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case CITIES_GET_REQUESTING:
            return {
                ...state,
                requesting: true,
                success: false,
                error: '',
            };
        case CITIES_GET_SUCCESS:
            return {
                ...state,
                requesting: false,
                success: true,
                cities: action.cities,
            };
        case CITIES_GET_ERROR:
            return {
                ...state,
                requesting: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default reducer;